// src/store/modules/onlineOrders.js
const state = {
    onlineOrders: [],
    deliveryZones: [
        { id: 1, name: "Centre-ville", deliveryTime: "25-35 min", fee: 2.5 },
        { id: 2, name: "Quartier Nord", deliveryTime: "35-45 min", fee: 3.5 },
        { id: 3, name: "Quartier Sud", deliveryTime: "30-40 min", fee: 3.0 }
    ],
    deliveryDrivers: [
        { id: 1, name: "Marc Livreur", status: "available", currentOrder: null },
        { id: 2, name: "Sophie Coursier", status: "on_delivery", currentOrder: 1001 }
    ]
};

const mutations = {
    ADD_ONLINE_ORDER(state, order) {
        state.onlineOrders.push(order);
    },
    UPDATE_ONLINE_ORDER_STATUS(state, { orderId, status }) {
        const order = state.onlineOrders.find(o => o.id === orderId);
        if (order) {
            order.status = status;
            order.updatedAt = new Date();
        }
    },
    ASSIGN_DRIVER(state, { orderId, driverId }) {
        const order = state.onlineOrders.find(o => o.id === orderId);
        const driver = state.deliveryDrivers.find(d => d.id === driverId);

        if (order && driver) {
            order.driverId = driverId;
            order.driverName = driver.name;
            driver.status = "on_delivery";
            driver.currentOrder = orderId;
        }
    },
    UPDATE_DRIVER_STATUS(state, { driverId, status, currentOrder }) {
        const driver = state.deliveryDrivers.find(d => d.id === driverId);
        if (driver) {
            driver.status = status;
            driver.currentOrder = currentOrder;
        }
    }
};

const actions = {
    createOnlineOrder({ commit, state }, orderData) {
        console.log("state",state)

        const newOrder = {
            id: Date.now(),
            ...orderData,
            status: 'pending',
            orderNumber: `OL${Date.now().toString().slice(-6)}`,
            createdAt: new Date(),
            updatedAt: new Date()
        };

        commit('ADD_ONLINE_ORDER', newOrder);

        // Notification automatique aux stations
        setTimeout(() => {
            commit('ADD_NOTIFICATION', {
                type: 'new_online_order',
                message: `Nouvelle commande en ligne #${newOrder.orderNumber}`,
                orderId: newOrder.id,
                priority: 'high'
            });
        }, 1000);

        return newOrder;
    },

    acceptOnlineOrder({ commit }, orderId) {
        commit('UPDATE_ONLINE_ORDER_STATUS', { orderId, status: 'accepted' });

        commit('ADD_NOTIFICATION', {
            type: 'order_accepted',
            message: `Commande #${orderId} acceptée et en préparation`,
            orderId
        });
    },

    rejectOnlineOrder({ commit }, orderId) {
        commit('UPDATE_ONLINE_ORDER_STATUS', { orderId, status: 'rejected' });

        commit('ADD_NOTIFICATION', {
            type: 'order_rejected',
            message: `Commande #${orderId} refusée`,
            orderId
        });
    },

    readyForPickup({ commit }, orderId) {
        commit('UPDATE_ONLINE_ORDER_STATUS', { orderId, status: 'ready_pickup' });

        commit('ADD_NOTIFICATION', {
            type: 'ready_pickup',
            message: `Commande #${orderId} prête à être récupérée`,
            orderId,
            priority: 'medium'
        });
    },

    assignDriver({ commit }, { orderId, driverId }) {
        commit('ASSIGN_DRIVER', { orderId, driverId });
        commit('UPDATE_ONLINE_ORDER_STATUS', { orderId, status: 'assigned' });
    },

    startDelivery({ commit }, orderId) {
        commit('UPDATE_ONLINE_ORDER_STATUS', { orderId, status: 'on_delivery' });

        commit('ADD_NOTIFICATION', {
            type: 'delivery_started',
            message: `Livraison commencée pour la commande #${orderId}`,
            orderId
        });
    },

    completeDelivery({ commit }, orderId) {
        commit('UPDATE_ONLINE_ORDER_STATUS', { orderId, status: 'delivered' });

        const driver = state.deliveryDrivers.find(d => d.currentOrder === orderId);
        if (driver) {
            commit('UPDATE_DRIVER_STATUS', {
                driverId: driver.id,
                status: 'available',
                currentOrder: null
            });
        }

        commit('ADD_NOTIFICATION', {
            type: 'delivery_completed',
            message: `Commande #${orderId} livrée avec succès`,
            orderId
        });
    }
};

const getters = {
    pendingOnlineOrders: state =>
        state.onlineOrders.filter(order => order.status === 'pending'),
    activeOnlineOrders: state =>
        state.onlineOrders.filter(order =>
            ['accepted', 'preparing', 'ready_pickup', 'assigned', 'on_delivery'].includes(order.status)
        ),
    availableDrivers: state =>
        state.deliveryDrivers.filter(driver => driver.status === 'available'),
    onlineOrdersByStatus: state => status =>
        state.onlineOrders.filter(order => order.status === status)
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};